import { IGetters } from './getters.types';
import { ITechnicalReportData } from '@/entities';
import { AppConstants as _app } from '@/shared/app.constants';
import {Utilities as _utils} from '@/shared/utilities';

export const getters: IGetters = {
    isRAG(state: ITechnicalReportData) {
        if (state.grantTemplate && state.grantTemplate.IsRAGTemplate) {
            return true;
        } else {
            return false;
        }
    },

    isStartingPeriod(state: ITechnicalReportData) {
        return state.isStartingPeriod || false;
    },

    selectedReport(state: ITechnicalReportData) {
        return state.selectedReport;
    },

    grantInfo(state: ITechnicalReportData) {
        return state.grantInfo;
    },

    technicalReportSections(state: ITechnicalReportData) {
        return state.techReportTemplate;
    },

    finalTechnicalReportSections(state: ITechnicalReportData) {
        return state.grantTemplate.finalTechnicalReportSections;
    }
}